import { Box, Divider, Typography } from "@mui/material";
import React, { useContext } from "react";
import CustomTypography from "../../components/CustomTypography";
import AppContext from "../../config/AppContext";
import { getSystemSettings } from "../../services/EventService";
import { getRandomColorVariantBasedOnAppName } from "./Day";
import { TimesheetContext } from "../../util/context";


export default function ActivityEventDetails(props) {
  const { mode } = useContext(AppContext);
  const { subEventSelected = [], SetSubEventSelected = () => { } } = useContext(TimesheetContext);

  function formatTime(seconds) {
      
      let hours = Math.floor(seconds / 3600);
      let remainingMinutes = Math.floor((seconds % 3600) / 60);
      let remainingSeconds = Math.round(seconds % 60);
      if(remainingSeconds==60){
        remainingMinutes +=1;
        remainingSeconds=0;
      }
      if(remainingMinutes==60){
        hours +=1;
        remainingMinutes=0;
      }
      let h = hours < 10 ? "0" + hours : hours;
      let m = remainingMinutes < 10 ? "0" + remainingMinutes : remainingMinutes;
      let s = remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;
      return `${h}:${m}:${s}`;
    
  }

  return (
    <div
      style={{
        backgroundColor: "transparent",
        py: "8px",
        width: "100%",
        maxHeight: "400px",
        overflowX: "hidden",
        overflowY: "auto",
      }}
    >
      {props.event?.events?.map((app, index) => {
        let eventTime =
          app.start.toLocaleTimeString("en-US", {
            hour12: Number(getSystemSettings("timeformat")) === 12,
          }) +
          " - " +
          app.end.toLocaleTimeString("en-US", {
            hour12: Number(getSystemSettings("timeformat")) === 12,
          });
        let appTitle = app?.data?.app?.toLowerCase().includes("lockapp")
          ? "Idle Time"
          : app?.title?.replace("*", "");
        if (!appTitle) appTitle = app?.data?.app?.split(".")[0];
        const eventIsLogged = app?.projectId != null;
        const eventBackgroundColor = eventIsLogged && !subEventSelected?.includes(app.eventId) ? mode === "dark" ? "#010101" : "#D9D9D9" :
          subEventSelected?.includes(app.eventId) ? "#919191" :
            getRandomColorVariantBasedOnAppName(app.application?.name).light
        const loggedBorderColor = eventIsLogged && !subEventSelected?.includes(app.eventId) ? "#707070" :
          subEventSelected?.includes(app.eventId) ? "#4F4F4F" :
            getRandomColorVariantBasedOnAppName(app.application?.name).dark

        return (
          <div
            style={{
              background: eventBackgroundColor,
              height: "100%",
              display: "flex",
              borderLeft: "4px solid",
              borderColor: loggedBorderColor

            }}
            id={app?.event_id}
          >
            <Divider />
            <Box
              display={"flex"}
              pl={1}
              sx={{ width: "100%" }}
              flexDirection={"row"}
            >
              <span
                className="bullet"
                style={{
                  color: mode === "dark" ? "white" : "#242424",
                  opacity: "0.5",
                  fontSize: "25px",
                }}
              >
                •
              </span>
              <Box
                display={"flex"}
                sx={{ flexGrow: "1", paddingTop: "8px", maxWidth: "95%" }}
                flexDirection={"column"}
              >
                <Box
                  item
                  flexGrow={1}
                  px={1}
                  sx={{
                    flexWrap: "nowrap",
                    overflowWrap: "break-word",
                  }}
                >
                  <Box display={"block"} alignItems={"flex-start"}>
                    <Box>
                      <CustomTypography
                        title={appTitle}
                        textTransform={"capitalize"}
                        sx={{
                          font: "font: normal normal normal 12px/17px Gotham",
                          color: "var(--text-color-3)",
                        }}
                      >
                        {appTitle}
                      </CustomTypography>
                    </Box>
                    <Box>
                      <Typography
                        variant="text_10_10_1_1_m"
                        sx={{
                          color: "var(--text-color-7) !important",
                          font: "normal normal normal 12px/14px Gotham",
                        }}
                      >
                        {formatTime(app?.duration)}
                      </Typography>
                    </Box>

                    {app?.data?.url !== null &&
                      app?.data?.url !== undefined && (
                        <Box maxWidth={"99%"} display={"flex"} py={0.5}>
                          <CustomTypography
                            title={app?.data?.url}
                            variant="text_10_10_1_1_m"
                            sx={{
                              color: "var(--text-color-7) !important",
                              font: "normal normal bold 10px/10px Gotham",
                            }}
                          >
                            {"URL: " + app?.data?.url}
                          </CustomTypography>
                        </Box>
                      )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </div>
        );
      })}
    </div>
  );
}
